export default "__VITE_ASSET__DSCqGt3e__"